import { PropsWithChildren } from 'react';

import { Tooltip } from '@cast/design-system';
import { NodeResourceOffering } from '@cast/types';

import {
  ResourceOfferingChip,
  ResourceOfferingChipProps,
} from 'components/chips';

type ResourceOfferingProps = PropsWithChildren<ResourceOfferingChipProps>;
export const ResourceOffering = ({
  children,
  ...props
}: ResourceOfferingProps) => (
  <Tooltip
    title="Temporary on-demand node while spot is not available"
    placement="top"
    disableHoverListener={
      props.resourceOffering !== NodeResourceOffering.FALLBACK
    }
    arrow
  >
    {children ? <div>{children}</div> : <ResourceOfferingChip {...props} />}
  </Tooltip>
);
